import { StyledRouterLink } from 'components/atoms/RouterLink/styles';
import { ERouteLinks } from 'models/route';
import React, { useEffect } from 'react';
import { getLegalEntityType } from 'components/organisms/RegisteredFirearmDetails';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { useAccount } from 'pages/AccountPage/hooks';
import { ELegalVisibility } from 'constants/LegalVisibility';
import { ELegalEntityTypes } from 'constants/LegalEntityTypes';

type StyledLegalLinkProps = {
  labelText: string | null | undefined;
  legalType: string | null | undefined;
  legalId: string | null | undefined;
  legalVisibilityUniqueId: string | null | undefined;
  legalPrefixGroupUniqueId?: string | null;
  legalOrganisationCategoryUniqueId?: string | null;
};

export const StyledLegalLink = ({
  labelText,
  legalId,
  legalType,
  legalVisibilityUniqueId,
  legalPrefixGroupUniqueId,
  legalOrganisationCategoryUniqueId,
}: StyledLegalLinkProps) => {
  const { hasPermissions } = usePermission();
  const { account, getSelfAccountData } = useAccount();

  const hasViewLEPermissionAndLegalVisibilityisPublicOrNonPublicAndAssigned =
    !!legalId &&
    hasPermissions([EPermission.VIEW_LE]) &&
    (legalVisibilityUniqueId === ELegalVisibility.PUBLIC ||
      (legalVisibilityUniqueId === ELegalVisibility.NON_PUBLIC &&
        account?.assignedLegalIds.includes(legalId)));

  const shouldVerifyPrefixGroupOrOrganisationCategory =
    legalPrefixGroupUniqueId || legalOrganisationCategoryUniqueId;

  const hasPrefixGroupRights =
    legalPrefixGroupUniqueId &&
    legalType === ELegalEntityTypes.individual &&
    account?.prefixGroupIds.includes(legalPrefixGroupUniqueId);

  const hasOrganisationCategoryRights =
    legalOrganisationCategoryUniqueId &&
    legalType === ELegalEntityTypes.organisation &&
    account?.organisationCategoryIds.includes(legalOrganisationCategoryUniqueId);

  const hasLEPermissions =
    !!legalId &&
    (!shouldVerifyPrefixGroupOrOrganisationCategory ||
      hasPrefixGroupRights ||
      hasOrganisationCategoryRights) &&
    (hasPermissions([EPermission.VIEW_ALL_LE]) ||
      hasViewLEPermissionAndLegalVisibilityisPublicOrNonPublicAndAssigned);

  useEffect(() => {
    (async () => {
      await getSelfAccountData();
    })();
  }, []);

  if (hasLEPermissions) {
    return labelText && legalType && legalId ? (
      <StyledRouterLink
        to={`${ERouteLinks.ViewLegalEntity.replace(':id', legalId)}?type=${getLegalEntityType(
          legalType,
        )}`}
      >
        {labelText}
      </StyledRouterLink>
    ) : (
      '-'
    );
  }
  return emptyFieldHolder(labelText);
};
